<template>
  <div class="buttonGroup" v-bind:class="cssStepValue">
    <div class="buttonGroup-Inner">
      <button
        v-on:click="onnext"
        v-if="instruction == 1"
        class="startButton"
        alt="start ballot"
        width="120px"
        v-bind:src="startButton"
	
      >
      <span v-if="buttonText.start">{{ buttonText.start }}</span>
      </button>
	   <button
        v-on:click="onprevious($event)"
        v-if="(instruction > 1 && instruction < 6) || instruction == 6"
        :disabled="disable"
        class="prev"
        alt="previous round"
        width="30px"
        v-bind:src="previousButton"
      >
        Previous
      </button>
      <button
        v-on:click="onreset($event)"
        v-if="instruction == 6"
        class="startover"
        alt="startover ballot"
        width="120px"
        v-bind:src="startOverButton"
        :disabled="disable"
      >
        <span v-if="buttonText.startOver">{{ buttonText.startOver }}</span>
      </button>
      <div class="roundsLabel" v-if="this.instruction && this.oftest">
        {{ this.instruction }} {{ this.oftest }} 6
      </div>

     

      <button
        v-on:click="onnext"
        v-if="instruction > 1 && instruction < 6"
        class="next"
        alt="next round"
        width="30px"
        v-bind:src="nextButton"
      >
        Next
      </button>
    </div>
  </div>
</template>

<script>
import nextButton from "../assets/button-next.svg";
import startButton from "../assets/button-start.svg";
import previousButton from "../assets/button-previous.svg";
import startOverButton from "../assets/button-startover.svg";

export default {
  name: "ButtonComponent",

  data() {
    return {};
  },

  props: ["instruction", "disable", "oftest", "buttonText"],

  computed: {
    cssStepValue: function() {
      let cssStepValue = "";
      if (this.instruction == 1) {
        cssStepValue = "stepOne";
      } else if (this.instruction === 6) {
        cssStepValue = "stepSix";
      }
      return cssStepValue;
    },

    startButton: function() {
      return startButton;
    },
    nextButton: function() {
      return nextButton;
    },
    previousButton: function() {
      return previousButton;
    },
    startOverButton: function() {
      return startOverButton;
    }
  },

  methods: {
    onprevious(e) {
      this.$emit("onprevious");
    },

    onnext() {
      this.$emit("onnext");
    },

    onstart() {
      this.$emit("startover");
    },

    onreset(e) {
      this.$emit("onreset");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ButtonComponent.vue